// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3MeFC","label":"CategoryService_label__2Hfj4","location":"CategoryService_location__RhAt2"};